import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcDeadlineViolationReasonInputComponent } from './fc-deadline-violation-reason-input.component';


@NgModule({
  declarations: [
    FcDeadlineViolationReasonInputComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FcSearchInputModule,
  ],
  exports: [
    FcDeadlineViolationReasonInputComponent
  ]
})
export class FcDeadlineViolationReasonInputModule { }
